import { useEffect, useState } from 'react'
import '../../assets/styles/customFilter.css'

const CustomCheckListFilter = ({ packageData, colDef, setApiParams }) => {
  const { id } = colDef
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({});
  const [filterOptions, setFilterOptions] = useState(packageData); // Store dynamic filter options

  useEffect(() => {
    setApiParams(oldParams => {
      try {
        const selectedItems = Object.entries(filters)
          .filter(([key, value]) => value === true && key !== 'selectAll')
          .map(([key]) => key);

        if (!selectedItems || selectedItems?.length == 0) {
          return {
            ...oldParams,
            filterCols: [...oldParams.filterCols.filter(filter => filter.colId !== id)]
          }
        } else {

          const newFilterColDef = {
            colId: id,
            filterType: 'checkList',
            filterData: selectedItems,
            dataType: 'string'
          }

          return {
            ...oldParams,
            filterCols: oldParams.filterCols.find(filter => filter.colId === id) ?
              [...oldParams.filterCols.filter(filter => filter.colId !== id), newFilterColDef] :
              [...oldParams.filterCols, newFilterColDef]
          }
        }

      } catch (error) {
        console.log(error)
        return { ...oldParams }
      }
    })
  }, [filters])

  // Handle checkbox change
  const handleCheckboxChange = (e) => {

    const { name, checked } = e.target;
    if (!name) {
      console.error('Checkbox name is missing or invalid:', e.target);
      return;
    }

    const newFilters = {
      ...filters,
      [name]: checked,
    };

    if (name === 'selectAll') {
      filterOptions.forEach(option => {
        newFilters[option.packageId] = checked;
      });
    } else if (filters.selectAll && !checked) {
      newFilters.selectAll = false;
    } else {
      const individualOptions = filterOptions.map(option => option.packageId);
      const allSelected = individualOptions.every(optionName => newFilters[optionName] === true);
      if (allSelected) {
        newFilters.selectAll = true;
      }
    }

    setFilters(newFilters);
  };

  // Reset all filters
  const resetFilters = () => {
    setSearchTerm('');
    setFilters({
      selectAll: false,
      ...filterOptions.reduce((acc, option) => ({
        ...acc,
        [option.packageId]: false,
      }), {}),
    });

    setFilterOptions(packageData);
  };

  const searchTerms = (data) => {
    if (data != "") {
      const filteredData = packageData?.filter(item =>
        item.packageName?.toLowerCase().includes(data?.toLowerCase() || '')
      );
      setSearchTerm(data)
      setFilterOptions(filteredData);
    } else {

      setSearchTerm(data)
      setFilterOptions(packageData);
    }
  };

  return (
    <div className="filter-container">
      <input
        type="text"
        className="filter-search-input"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => searchTerms(e.target.value)}
      />

      <div className="filter-checkbox-group" style={{ maxHeight: '150px', overflowY: 'scroll' }}>

        <label className="filter-checkbox-label">
          <input
            type="checkbox"
            name="selectAll"
            checked={filters.selectAll || false}
            onChange={handleCheckboxChange}
          /> Select All
        </label>

        {filterOptions.map((option, index) => (
          <label key={index} className="filter-checkbox-label">
            <input
              type="checkbox"
              value={option.packageId}
              name={option.packageId}
              checked={filters[option.packageId] || false}
              onChange={handleCheckboxChange}
            /> {option.packageName}
          </label>
        ))}
      </div>

      <button onClick={resetFilters} style={{ marginTop: '10px', padding: '5px 15px' }} >
        Reset filter
      </button>

    </div>
  )
}

export default CustomCheckListFilter
